// extracted by mini-css-extract-plugin
export var content = "_pp-1";
export var fullScreen = "_pp-0";